module.exports = __webpack_public_path__ + "static/media/janetwide.b61a3e31.png";